import { handleApiResponse } from '@/api/main/client'
import { mobileAxiosInstance } from '@/api/mobile/instance'
import { ApiResponse, QueryParams } from '@/api/types'
import { AxiosRequestConfig } from 'axios'

export async function mobileApiGet<T>(
  endpoint: string,
  params?: QueryParams,
  config?: Omit<AxiosRequestConfig, 'params'>
): Promise<T> {
  const response = await mobileAxiosInstance.get<ApiResponse<T>>(endpoint, {
    params,
    ...config,
  })
  return handleApiResponse(response.data)
}
